<template>
  <div class="ib-tool">
    <!-- Upload -->
    <div class="editor-pane" v-if="!resultUrl">
      <div class="pane-header">
        <span class="pane-dot input-dot" /><span class="pane-label">{{ $t('tool.ImageBgRemove.title') }}</span>
        <span class="pane-hint">PNG / JPEG · 50MB</span>
      </div>
      <el-upload ref="upload" drag action="#" :auto-upload="false" :on-change="handleFile" :limit="1"
        accept="image/png,image/jpeg,image/webp" :file-list="fileList">
        <i class="el-icon-picture-outline" style="font-size:42px;color:#c0c4cc" />
        <div class="el-upload__text">{{ $t("tool.ImageBgRemove.dropText") }}<em>{{ $t("tool.ImageBgRemove.clickUpload") }}</em></div>
      </el-upload>

      <div v-if="file" class="ib-config">
        <!-- 推荐底色 -->
        <div class="ib-preset-row">
          <span class="ib-ctrl-lbl">推荐底色</span>
          <span v-for="opt in colorOptions" :key="opt.color"
            class="ib-preset-btn"
            :class="{ on: replaceColor === opt.color }"
            @click="replaceColor = opt.color">
            <span class="preset-swatch" :style="{background:opt.color}"></span>
            {{ opt.label }}
          </span>
        </div>
        <div class="ib-config-row">
          <div class="ib-config-item">
            <span class="ib-ctrl-lbl">自定义颜色</span>
            <el-color-picker v-model="replaceColor" size="small" />
            <code class="ib-ctrl-val">{{ replaceColor }}</code>
          </div>
          <div class="ib-config-item ib-config-tol">
            <span class="ib-ctrl-lbl">精度调节 {{ tolerance }}%</span>
            <el-slider v-model="tolerance" :min="1" :max="50" style="width:120px" />
          </div>
          <el-button type="primary" size="small" :loading="loading" @click="process">开始处理</el-button>
        </div>
      </div>
    </div>

    <!-- Result -->
    <div class="ib-result" v-if="resultUrl">
      <div class="ib-result-hd">
        <span class="pane-dot output-dot" />
        <span class="pane-label">{{ $t('tool.ImageBgRemove.title') }}</span>
      </div>
      <div class="ib-compare">
        <div class="ib-compare-item">
          <p>原图</p>
          <img :src="originalUrl" />
        </div>
        <div class="ib-compare-item">
          <p>换底结果</p>
          <img :src="resultUrl" />
        </div>
      </div>
      <div class="ib-result-actions">
        <el-button size="small" type="primary" icon="el-icon-download" @click="download">{{ $t('tool.ImageBgRemove.download') }}</el-button>
        <el-button size="small" plain @click="reset">{{ $t('tool.ImageBgRemove.reupload') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'ImageBgRemoveTool',props:{config:{type:Object,default:()=>({})}},
  data:()=>({
    file:null,fileList:[],loading:false,
    detectedBg:'#FFFFFF',replaceColor:'#438EDB',
    tolerance:10,originalUrl:'',resultUrl:'',
    colorOptions:[
      {label:'红底',color:'#D9382C'},
      {label:'白底',color:'#FFFFFF'},
      {label:'蓝底',color:'#438EDB'},
    ]
  }),
  methods:{
    handleFile(f){
      if(f.size>50*1024*1024){this.$message.error('最大50M');return}
      this.file=f.raw;this.fileList=[f];
      const r=new FileReader();
      r.onload=(e)=>{
        this.originalUrl=e.target.result;
        this.detectBgColor(e.target.result);
      };
      r.readAsDataURL(f.raw)
    },
    detectBgColor(dataUrl){
      const img=new Image();
      img.onload=()=>{
        const c=document.createElement('canvas');
        const scale=Math.min(1,200/Math.max(img.width,img.height));
        c.width=img.width*scale;c.height=img.height*scale;
        const ctx=c.getContext('2d');ctx.drawImage(img,0,0,c.width,c.height);
        const d=ctx.getImageData(0,0,c.width,c.height);const p=d.data;
        const w=c.width,h=c.height;
        const samples=[];
        const margin=Math.max(2,Math.floor(Math.min(w,h)*0.05));
        for(let x=margin;x<w-margin;x++){
          for(let y=0;y<margin;y++) samples.push((y*w+x)*4);
          for(let y=h-margin;y<h;y++) samples.push((y*w+x)*4);
        }
        for(let y=margin;y<h-margin;y++){
          for(let x=0;x<margin;x++) samples.push((y*w+x)*4);
          for(let x=w-margin;x<w;x++) samples.push((y*w+x)*4);
        }
        const q=8;const map={};let bestKey='',bestCnt=0;
        for(const off of samples){
          const r=Math.floor(p[off]/q),g=Math.floor(p[off+1]/q),b=Math.floor(p[off+2]/q);
          const key=r+','+g+','+b;
          const cnt=(map[key]||0)+1;map[key]=cnt;
          if(cnt>bestCnt){bestCnt=cnt;bestKey=key}
        }
        const parts=bestKey.split(',').map(Number);
        const hexR=(parts[0]*q).toString(16).padStart(2,'0');
        const hexG=(parts[1]*q).toString(16).padStart(2,'0');
        const hexB=(parts[2]*q).toString(16).padStart(2,'0');
        this.detectedBg='#'+hexR+hexG+hexB;
      };
      img.src=dataUrl
    },
    process(){
      if(!this.file||this.loading)return;this.loading=true;
      const img=new Image();
      img.onload=()=>{
        const c=document.createElement('canvas');c.width=img.width;c.height=img.height;
        const ctx=c.getContext('2d');ctx.drawImage(img,0,0);
        const d=ctx.getImageData(0,0,c.width,c.height);const p=d.data;
        const w=c.width, h=c.height, total=w*h;

        const tR=parseInt(this.detectedBg.slice(1,3),16),
              tG=parseInt(this.detectedBg.slice(3,5),16),
              tB=parseInt(this.detectedBg.slice(5,7),16);
        const rR=parseInt(this.replaceColor.slice(1,3),16),
              rG=parseInt(this.replaceColor.slice(3,5),16),
              rB=parseInt(this.replaceColor.slice(5,7),16);
        const max = this.tolerance * 2.55;

        const isBg = new Uint8Array(total);
        for (let i=0;i<total;i++) {
          const off=i*4;
          if (Math.abs(p[off]-tR)<=max && Math.abs(p[off+1]-tG)<=max && Math.abs(p[off+2]-tB)<=max) {
            isBg[i]=1;
          }
        }

        const visited=new Uint8Array(total);
        const queue=[];
        const push=(x,y)=>{
          if(x<0||x>=w||y<0||y>=h)return;
          const idx=y*w+x;if(!isBg[idx]||visited[idx])return;
          visited[idx]=1;queue.push(x,y)
        };
        for(let x=0;x<w;x++){push(x,0);push(x,h-1)}
        for(let y=0;y<h;y++){push(0,y);push(w-1,y)}
        while(queue.length){
          const y=queue.pop(),x=queue.pop();
          push(x-1,y);push(x+1,y);push(x,y-1);push(x,y+1);
        }

        for(let i=0;i<total;i++){
          if(visited[i]){
            const off=i*4;
            p[off]=rR;p[off+1]=rG;p[off+2]=rB;p[off+3]=255;
          }
        }

        ctx.putImageData(d,0,0);
        this.resultUrl=c.toDataURL('image/png');
        this.loading=false;
      };
      img.onerror=()=>{this.$message.error('图片加载失败');this.loading=false};
      img.src=this.originalUrl
    },
    reset(){this.resultUrl='';this.file=null;this.fileList=[];this.originalUrl=''},
    download(){const a=document.createElement('a');document.body.appendChild(a);a.href=this.resultUrl;a.download='result.png';a.click();document.body.removeChild(a)},
    doAction(a){if(a==='clear')this.reset()}
  }
}
</script>

<style scoped>
.ib-tool { display:flex;flex-direction:column;gap:16px; }

.editor-pane { background:#fafbfc;border-radius:12px;border:1px solid #ebeef5;padding:16px 20px; min-width:0; overflow:hidden; }
.pane-header { display:flex;align-items:center;gap:8px;margin-bottom:12px; flex-wrap:wrap; }
.pane-dot { width:8px;height:8px;border-radius:50%;flex-shrink:0; }
.input-dot { background:#4e7cff;box-shadow:0 0 6px rgba(78,124,255,.4); }
.output-dot { background:#43e97b;box-shadow:0 0 6px rgba(67,233,123,.4); }
.pane-label { font-size:13px;font-weight:700;color:#1a1f36; }
.pane-hint { font-size:11px;color:#b0b8c4;margin-left:auto; white-space:nowrap; }
.ib-tool ::v-deep .el-upload { width:100%; }
.ib-tool ::v-deep .el-upload-dragger { display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:170px; max-width:100%; width:100%; box-sizing:border-box; }

.ib-config { margin-top:14px; }
.ib-config-row { display:flex;align-items:center;gap:14px;flex-wrap:wrap; margin-top:10px; }
.ib-config-item { display:flex;align-items:center;gap:6px; }
.ib-config-tol { min-width:180px; }
.ib-ctrl-lbl { font-size:12px;color:#909399;white-space:nowrap; }
.ib-ctrl-val { font-size:12px;color:#c0c4cc;font-family:monospace; }

.ib-preset-row { display:flex;align-items:center;gap:10px; }
.ib-preset-btn {
  display:flex;align-items:center;gap:6px;
  padding:6px 14px;border-radius:6px;border:2px solid #e4e7ed;
  background:#fff;cursor:pointer;font-size:13px;color:#606266;
  transition:all .15s;user-select:none;
}
.ib-preset-btn:hover { border-color:#909399; }
.ib-preset-btn.on { border-color:#4e7cff;box-shadow:0 0 0 3px rgba(78,124,255,.12);color:#4e7cff;font-weight:600; }
.preset-swatch { width:16px;height:16px;border-radius:4px;border:1px solid rgba(0,0,0,.08);flex-shrink:0; }

.ib-result { background:#f0f9eb;border:1px solid #e1f3d8;border-radius:12px;padding:20px 24px; }
.ib-result-hd { display:flex;align-items:center;gap:8px;margin-bottom:16px; }
.ib-result-actions { display:flex;gap:8px;margin-top:16px; }
.ib-compare { display:flex;gap:20px; }
.ib-compare-item { flex:1;text-align:center; }
.ib-compare-item p { font-size:12px;color:#909399;margin-bottom:8px;font-weight:600; }
.ib-compare-item img { max-width:100%;max-height:320px;border:1px solid #e4e7ed;border-radius:8px;background:#fff; }

@media (max-width: 640px) {
  .editor-pane { padding:12px 14px; }
  .pane-hint { display:none; }
  .ib-tool ::v-deep .el-upload-dragger { min-height:140px;padding:20px 12px; }
  .ib-tool ::v-deep .el-upload__text { font-size:12px; }
  .ib-compare { flex-direction:column; }
  .ib-result { padding:14px 16px; }
  .ib-config-row { flex-direction:column;align-items:flex-start; }
  .ib-config-tol { width:100%;min-width:0; }
  .ib-preset-row { flex-wrap:wrap; }
}
</style>
